<template>
    <div class="cards-container">
        <h2 class="cards-title small">{{ title }}</h2>
        <div class="cards-grid">
            <div
                v-for="(card, index) in cards"
                :key="index"
                class="card"
            >
                <div class="card-icon">
                    <div class="icon" :style="`background-image: url(${card.icon !== false ? card.icon : '/images/stars.svg'});`"></div>
                </div>
                <h3 class="card-title">{{ card.title }}</h3>
                <div class="card-content" v-html="card.content"/>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    cards: {
        type: Array,
        required: true,
        default: () => []
        // chaque carte: { icon: String|Component, title: String, content: String }
    }
})
</script>

<style scoped lang="scss">
.cards-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    max-width: 1350px;
    margin: 0 auto 230px;
}

.cards-title {
    margin: 165px auto 75px;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 50px;
}

.card {
    padding: 35px 50px 50px;
   border-radius: 25px;
    border: 1px solid #212F42;
    background: linear-gradient(306deg, #182030 3.7%, #080C10 94.28%);
}

.card-icon {
    width: 33px;
    aspect-ratio: 1;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 15px;

    & .icon{
        width: 100%;
        aspect-ratio: 1;
        object-fit: contain;
    }
}


.card-title {
    color: $white;
    font-size: 1.65em;
    margin-bottom: 25px;
}

.card-content {
    font-size: .9em;
}

@media (max-width: 900px) {
    .cards-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .cards-grid {
        grid-template-columns: 1fr;
    }
}
</style>